import Swiper from 'swiper';
import 'swiper_dir/css/swiper.min.css'

const swiper = new Swiper('.js-slider1', {
  slidesPerView: 1,
  effect: 'fade',
  autoplay: {
    delay: 3000,
    stopOnLastSlide:true
  },
  on: {
    init: function () {
      this.$el.parent().attr({'data-slider-number':this.activeIndex});
    },
    slideChange: function () {
      this.$el.parent().attr({'data-slider-number':this.activeIndex});
    },
  }
});


export default swiper;